// src/i18n/login.js
export const LOGIN_TEXT = {
  nl: {
    title: "Inloggen",

    email: "E-mail",
    password: "Wachtwoord",
    forgotPassword: "Wachtwoord vergeten?",

    login: "Inloggen",
    loading: "Bezig...",
    loggingIn: "Inloggen...",
    ssoChecking: "Automatisch aanmelden via Verdonk Apps...",
    ssoNotices: {
      signedOut: "Je Verdonk Apps-sessie is verlopen. Log hieronder rechtstreeks in bij Kisten.",
      accessDenied: "Je Verdonk Apps-account heeft geen toegang tot Kisten. Je kunt hieronder met een ander Kisten-account inloggen.",
      configurationUnavailable: "Automatisch aanmelden via Verdonk Apps is nog niet beschikbaar. Log hieronder rechtstreeks in bij Kisten.",
      unavailable: "Verdonk Apps is tijdelijk niet bereikbaar. Log hieronder rechtstreeks in bij Kisten.",
    },

    resetSent:
      "Als dit e-mailadres bij een account hoort, is een reset-link verstuurd. Check ook je spam.",

    // validatie / meldingen
    fillEmailFirst: "Vul eerst je e-mailadres in.",
    resetFailed: "Kon geen reset-link versturen.",

    // auth errors (staff)
    invalidEmail: "Ongeldig e-mailadres.",
    userDisabled: "Dit account is uitgeschakeld.",
    userNotFound: "Geen account gevonden met dit e-mailadres.",
    wrongPassword: "Wachtwoord onjuist.",
    tooManyRequests: "Te veel mislukte pogingen. Probeer later opnieuw.",
    invalidCredential: "E-mail of wachtwoord klopt niet.",
    loginFailed: "Inloggen mislukt. Probeer het opnieuw.",
  },

  en: {
    title: "Login",

    email: "Email",
    password: "Password",
    forgotPassword: "Forgot password?",

    login: "Login",
    loading: "Loading...",
    loggingIn: "Logging in...",
    ssoChecking: "Signing in automatically through Verdonk Apps...",
    ssoNotices: {
      signedOut: "Your Verdonk Apps session has expired. Sign in to Kisten directly below.",
      accessDenied: "Your Verdonk Apps account has no access to Kisten. You can sign in with another Kisten account below.",
      configurationUnavailable: "Automatic sign-in through Verdonk Apps is not available yet. Sign in to Kisten directly below.",
      unavailable: "Verdonk Apps is temporarily unavailable. Sign in to Kisten directly below.",
    },

    resetSent:
      "If this email belongs to an account, a reset link has been sent. Please check spam as well.",

    fillEmailFirst: "Please enter your email first.",
    resetFailed: "Could not send reset link.",

    invalidEmail: "Invalid email address.",
    userDisabled: "This account is disabled.",
    userNotFound: "No account found with this email.",
    wrongPassword: "Incorrect password.",
    tooManyRequests: "Too many failed attempts. Try again later.",
    invalidCredential: "Email or password is incorrect.",
    loginFailed: "Login failed. Please try again.",
  },

  pl: {
    title: "Zaloguj",

    email: "Poczta",
    password: "Haslo",
    forgotPassword: "Zapomnialem hasla?",

    login: "Login",
    loading: "Ladowanie...",
    loggingIn: "Logowanie...",
    ssoChecking: "Automatyczne logowanie przez Verdonk Apps...",
    ssoNotices: {
      signedOut: "Sesja Verdonk Apps wygasla. Zaloguj sie ponizej bezposrednio do Kisten.",
      accessDenied: "Twoje konto Verdonk Apps nie ma dostepu do Kisten. Ponizej mozesz zalogowac sie innym kontem Kisten.",
      configurationUnavailable: "Automatyczne logowanie przez Verdonk Apps nie jest jeszcze dostepne. Zaloguj sie ponizej bezposrednio do Kisten.",
      unavailable: "Verdonk Apps jest tymczasowo niedostepne. Zaloguj sie ponizej bezposrednio do Kisten.",
    },

    resetSent:
      "Jesli ten adres e-mail nalezy do konta, link resetowania zostal wyslany. Sprawdz takze spam.",

    fillEmailFirst: "Najpierw podaj swoj adres e-mail.",
    resetFailed: "Nie udalo sie wyslac linku resetujacego.",

    invalidEmail: "Nieprawidlowy adres email.",
    userDisabled: "To konto jest wylaczone.",
    userNotFound: "Nie znaleziono konta o tym adresie.",
    wrongPassword: "Nieprawidlowe haslo.",
    tooManyRequests: "Zbyt wiele nieudanych prob. Sprobuj ponownie pozniej.",
    invalidCredential: "Adres email lub haslo sa nieprawidlowe.",
    loginFailed: "Logowanie nie powiodlo sie. Sprobuj ponownie.",
  },
};
